<mat-dialog-actions class="justify-content-between" *ngIf="isDialog">
    <div class="f-s-16 f-w-600 m-b-16">
        <h3>{{ 'ENTITY.PRESCRIPTION' | translate }}</h3>
    </div>
    <div class="dialog-header-actions">
        <button mat-icon-button *ngIf="canPrint && !isLoading" (click)="onPrintPrescription()"
            matTooltip="{{ 'BUTTON.BTN_PRINT' | translate }}">
            <i-tabler name="printer" class="icon-22 d-flex text-primary"></i-tabler>
        </button>
        <button mat-icon-button class="d-flex justify-content-center" (click)="onCloseDialog()">
            <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
        </button>
    </div>
</mat-dialog-actions>
<mat-divider *ngIf="isDialog"></mat-divider>
<mat-dialog-content
    [class.prescription-dialog-content]="isDialog"
    [class.embedded-prescription-content]="embedded">
    <div *ngIf="isLoading && !embedded" class="loader-wrapper">
        <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div class="table-container" [class.dialog-container]="isDialog">
        <div [ngClass]="{ 'prescription-dialog': isDialog }">
            <!-- Top Actions -->

            <ng-container *ngIf="!isLoading">
                <!-- Card 1: Diagnosis -->
                <div class="prescription-card m-t-10" *ngIf="!embedded">
                    <div class="card-header">
                        <h3><i-tabler name="report-medical" class="icon-22"></i-tabler> {{ 'LABEL.DIAGNOSIS' | translate
                            }}
                        </h3>
                    </div>
                    <form [formGroup]="prescriptionForm">
                        <mat-form-field appearance="outline" class="w-100 hide-hint">
                            <textarea matInput formControlName="diagnosis" readonly rows="2"
                                placeholder="Diagnosis will appear here..."></textarea>
                        </mat-form-field>
                    </form>
                </div>

                <!-- Card 2: Prescription Details -->
                <div class="prescription-card" *ngIf="!readOnly || prescriptionItems.length > 0">
                    <div class="card-header">
                        <h3><i-tabler name="pill" class="icon-22"></i-tabler>
                            {{ (readOnly ? 'ENTITY.PRESCRIPTION' : 'ENTITY.PRESCRIPTION_TEMPLATE') | translate }}
                        </h3>
                        <button mat-stroked-button color="primary" *ngIf="canAddTemplate && !readOnly"
                            (click)="OnPrescriptionTemplate()">
                            {{ 'BUTTON.BTN_ADD_TEMPLATE' | translate }}
                        </button>
                    </div>

                    <div class="template-toolbar" *ngIf="!readOnly">
                        <mat-form-field appearance="outline" class="template-search hide-hint">
                            <mat-label>{{ 'ENTITY.PRESCRIPTION_TEMPLATE' | translate }}</mat-label>
                            <input matInput type="text" [formControl]="templateCtrl" [matAutocomplete]="templateAuto"
                                placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }}" />
                            <mat-autocomplete #templateAuto="matAutocomplete"
                                (optionSelected)="onTemplateSelected($event.option.value)"
                                [displayWith]="displayTemplateName">
                                <mat-option *ngFor="let template of filteredTemplates" [value]="template">
                                    {{ template.name }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>

                    <div class="table-container">
                        <table class="modern-table">
                            <thead>
                                <tr>
                                    <th style="width: 25%;">{{ 'LABEL.DRUG_NAME' | translate }}</th>
                                    <th style="width: 15%;">{{ 'LABEL.DRUG_PATTERN' | translate }}</th>
                                    <th style="width: 15%;">{{ 'LABEL.DURATION' | translate }}</th>
                                    <th style="width: 20%;">{{ 'LABEL.MEAL_RELATION' | translate }}</th>
                                    <th style="width: 20%;">{{ 'LABEL.INSTRUCTION' | translate }}</th>
                                    <th style="width: 5%;" *ngIf="!readOnly"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (row of prescriptionRows.controls; track row; let index = $index) {
                                <tr [formGroup]="$any(row)">
                                    <td>
                                        <mat-form-field appearance="outline" class="w-100">
                                            <input type="text" matInput formControlName="drugName"
                                                [matAutocomplete]="autoDrug" (blur)="onRowComplete(index)" />
                                            <mat-autocomplete #autoDrug="matAutocomplete"
                                                (optionSelected)="onDrugSelected($event, index)"
                                                [displayWith]="displayDrug">
                                                <mat-option class="add-new-option" *ngIf="!readOnly"
                                                    (click)="openAddDrugDialogInline(index)">
                                                    <i-tabler name="plus" class="icon-16 m-r-8"></i-tabler>
                                                    {{ 'LABEL.ADD_LABEL' | translate }} New {{ 'ENTITY.DRUG' | translate
                                                    }}
                                                </mat-option>
                                                <mat-option *ngFor="let drug of rowFilteredDrugs$[index] | async"
                                                    [value]="drug">
                                                    {{ drug.name }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field appearance="outline" class="w-100">
                                            <input matInput formControlName="dosePattern" appDosePattern [times]="4"
                                                (suggestionsChange)="dosePatternSuggestions[index] = $event"
                                                [matAutocomplete]="autoDose" (blur)="onRowComplete(index)" />
                                            <mat-autocomplete #autoDose="matAutocomplete">
                                                <mat-option *ngFor="let pattern of dosePatternSuggestions[index]"
                                                    [value]="pattern">
                                                    {{ pattern }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field appearance="outline" class="w-100">
                                            <input matInput formControlName="duration" [matAutocomplete]="autoDuration"
                                                (input)="onInlineDurationInput($event, index)"
                                                (blur)="onRowComplete(index)" maxlength="20" />
                                            <mat-autocomplete #autoDuration="matAutocomplete">
                                                <mat-option *ngFor="let suggestion of durationSuggestions[index]"
                                                    [value]="suggestion">
                                                    {{ suggestion }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-select formControlName="mealRelation"
                                                (selectionChange)="onRowComplete(index)">
                                                <mat-option *ngFor="let meal of mealRelationList" [value]="meal">
                                                    {{ mealRelationData[meal] }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field appearance="outline" class="w-100">
                                            <input matInput formControlName="instruction" (blur)="onRowComplete(index)"
                                                maxlength="4000" />
                                        </mat-form-field>
                                    </td>
                                    <td class="text-center" *ngIf="!readOnly">
                                        <button mat-icon-button color="warn"
                                            *ngIf="prescriptionRows.length > 1 && !isLastRow(index)"
                                            (click)="onDeleteRow(index)">
                                            <i-tabler name="trash" class="icon-18"></i-tabler>
                                        </button>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Card 3: Treatment Advice -->
                @if (!prescriptionForm.get('ipdId')?.value) {
                <div class="prescription-card">
                    <div class="card-header">
                        <h3><i-tabler name="note" class="icon-22"></i-tabler> {{ 'LABEL.TREATMENT_ADVICE' | translate }}
                        </h3>
                    </div>
                    <form [formGroup]="prescriptionForm">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{ 'LABEL.TREATMENT_ADVICE' | translate }}</mat-label>
                            <textarea matInput formControlName="treatmentAdviceOPD" rows="2"></textarea>
                            <a mat-icon-button matSuffix type="button" (click)="openTemplatePopupforTreatmentAdvice()"
                                [matTooltip]="'ENTITY.TEMPLATE' | translate">
                                <i-tabler name="file-text" class="icon-18"></i-tabler>
                            </a>
                        </mat-form-field>
                    </form>
                </div>

                <!-- Card 4: Follow-Up Appointment (OPD only) -->
                <div class="prescription-card">
                    <div class="card-header">
                        <h3><i-tabler name="calendar-event" class="icon-22"></i-tabler>
                            {{ 'APPOINTMENT_RELATED.FOLLOW_UP_APPOINTMENT' | translate }}
                        </h3>
                    </div>
                    <app-follow-up-slot-picker
                        *ngIf="followUpPickerDoctorId"
                        [doctorId]="followUpPickerDoctorId"
                        [required]="false"
                        [disabled]="readOnly"
                        [initialValue]="followUpInitialValue"
                        (valueChange)="onFollowUpValueChange($event)">
                    </app-follow-up-slot-picker>
                </div>
                }
            </ng-container>
        </div>
    </div>
</mat-dialog-content>
<mat-divider *ngIf="!isLoading && !embedded"></mat-divider>
<mat-dialog-actions class="prescription-footer-actions" *ngIf="!isLoading && !embedded">
    <div class="action-buttons">
        <button mat-icon-button *ngIf="canPrint && !isDialog" (click)="onPrintPrescription()"
            matTooltip="{{ 'BUTTON.BTN_PRINT' | translate }}">
            <i-tabler name="printer" class="icon-22 d-flex text-primary"></i-tabler>
        </button>

        <a mat-stroked-button color="primary" (click)="onCloseDialog()" *ngIf="isDialog">
            {{ 'BUTTON.BTN_CLOSE' | translate }}
        </a>
        <button mat-flat-button color="primary" (click)="onSaveAndUpdate()" [disabled]="prescriptionForm.invalid || isLoading">
            {{ 'BUTTON.BTN_SAVE' | translate }}
        </button>
    </div>
</mat-dialog-actions>
